import $ from 'jquery';

export function linkDecrypt() {
  var $link;

  $('[data-href]').each(function() {
    $link = $('<a />')
      .attr('href', hex2bin($(this).data('href')))
      .attr('target', $(this).data('target'))
      .attr('class', $(this).attr('class'))
      .append(this.innerHTML)
    ;

    $(this).replaceWith($link);
  });
}

function hexdec (hex_string) {
  hex_string = (hex_string + '').replace(/[^a-f0-9]/gi, '');
  return parseInt(hex_string, 16);
}

function chr(AsciiNum) {
  return String.fromCharCode(AsciiNum);
}

function hex2bin(hex){
  var r = '',
      a = 0;

  for (a = 0; a < hex.length; a = a + 2) {
      r = r + chr(hexdec(hex.slice(a, a + 2)));
  }

  return r;
}
